import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum InterpreterEnum {
    Yes = 1,
    No = 2,
    UnableToDetermine = 3
}

export class HosConvertToPendingInterpreter extends EnumWithDescription<InterpreterEnum> {
    public readonly enum = Interpreter;
    public readonly enumName: string = "Interpreter";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<InterpreterEnum>> = new Map([
        [
            "No",
            {
                value: InterpreterEnum.No,
                name: "No"
            }
        ],
        [
            "Yes",
            {
                value: InterpreterEnum.Yes,
                name: "Yes"
            }
        ],

        [
            "UnableToDetermine",
            {
                value: InterpreterEnum.UnableToDetermine,
                name: "Unable to Determine"
            }
        ]
    ]);
}

export const Interpreter = new HosConvertToPendingInterpreter();
